import React from "react";

function DummyComp(props) {
  return <div>comming soon</div>;
}

export default DummyComp;
